var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length)?_c('div',{staticClass:"finance-month"},[_c('div',{staticClass:"section-label"},[_vm._v("期数")]),_c('OptionBox',{attrs:{"options":_vm.options,"value":String(_vm.value)},on:{"change":_vm.selectMonth}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }